export const SET_DATA = 'profile/SET_DATA'
export const SET_MULTIPLE_DATA = 'profile/SET_MULTIPLE_DATA'
export const SET_IS_FETCHING = 'profile/SET_IS_FETCHING'
export const SET_IS_FETCHING_OBSERVATIONS = 'profile/SET_IS_FETCHING_OBSERVATIONS'
export const SET_IS_FETCHING_PUSH_OFFERS = 'profile/SET_IS_FETCHING_PUSH_OFFERS'
export const SET_IS_FETCHING_USER_LIST = 'profile/SET_IS_FETCHING_USER_LIST'
export const SET_OBSERVATIONS = 'profile/SET_OBSERVATIONS'
export const SET_PUSH_OFFERS = 'profile/SET_PUSH_OFFERS'
